<template>
    <div class="overlay">
        <div class="overlay_inner warning">
            <p class="note">{{ text }}</p>
            <p class="buttons">
              <a class="btn btn_darkblue" @click.stop.prevent="onClick()">OK</a>
            </p>
        </div>
    </div>
</template>

<script>
	export default {
		name: "Popup",
		props: {
			popupAction: Function,
      text: String,
		},
    methods:{
      onClick(){
        this.popupAction();
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/common/PopupAlert.vue